import React, { useState, useEffect } from "react";
import { Container, Row, Col, Table, Card, Pagination } from "react-bootstrap";
import "../../activityreport.css";
import { useSelector, useDispatch } from "react-redux";
import { getActivity } from "../../store/slices/user";

import { IoIosArrowForward } from "react-icons/io";
import { Link } from "react-router-dom";

export default function ActivityReport() {
  const dispatch = useDispatch();
  const { activityList, loading } = useSelector((state) => state.user);

  const [type, setType] = useState("");
  const [filter, setFilter] = useState("All");
  const [currentPage, setCurrentPage] = useState(1);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");

  const perPage = 10;
  const [meta, setMeta] = useState({
    total: 0,
    page: 1,
    limit: perPage,
  });

  const getFilterParams = () => {
    if (filter === "All") return {};

    if (filter === "Match") {
      return { type: "INTEREST_SENT" };
    }

    if (filter === "Shortlist") {
      return { type: "SHORTLISTED" }; // if exists
    }

    if (filter === "Payment") {
      return { type: "PAYMENT" };
    }

    if (filter === "Report") {
      return { type: "REPORT" };
    }

    return {};
  };

  useEffect(() => {
    const filterParams = getFilterParams();

    dispatch(
      getActivity({
        page: currentPage,
        limit: perPage,
        type,
        fromDate,
        toDate,
        ...filterParams,
      }),
    ).then((res) => {
      const payload = res.payload || {};

      setMeta({
        total: payload.total || 0,
        page: payload.page || currentPage,
        limit: payload.limit || perPage,
      });
    });
  }, [dispatch, currentPage, type, fromDate, toDate, filter]);

  const total = meta.total;
  const totalPages = Math.max(1, Math.ceil(total / perPage));
  const startIndex = (currentPage - 1) * perPage;
  const currentData = activityList || [];
  return (
    <>
      <div className="breadcrumb-bar mb-4">
        <div className="breadcrumb-left">
          <Link to="/admin/home" className="breadcrumb-link active">
            Home
          </Link>

          <span className="breadcrumb-separator">
            {" "}
            <IoIosArrowForward size={15} />{" "}
          </span>

          <span className="breadcrumb-link inactive">Activity</span>
        </div>
      </div>

      <Container className="wrap ">
        <Row>
          <Col xs={12}>
            <Card className="customtable-card">
              <Row className="align-items-center  mx-2 my-3">
                <Col>
                  <div className="ar-filter-row">
                    <div className="ar-left-filters">
                      <input
                        type="date"
                        value={fromDate}
                        onChange={(e) => {
                          setFromDate(e.target.value);
                          setCurrentPage(1);
                        }}
                        className="ar-date"
                      />

                      <input
                        type="date"
                        value={toDate}
                        onChange={(e) => {
                          setToDate(e.target.value);
                          setCurrentPage(1);
                        }}
                        className="ar-date"
                      />

                      {["All", "Shortlist", "Match", "Payment", "Report"].map(
                        (f, i) => (
                          <button
                            key={i}
                            className={`ar-chip ${filter === f ? "active" : ""}`}
                            onClick={() => {
                              setFilter(f);
                              setCurrentPage(1);
                            }}
                          >
                            {f}
                          </button>
                        ),
                      )}
                    </div>
                  </div>
                </Col>
              </Row>

              <div className="table-responsive">
                <Table className="custom-table align-middle text-center">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>From Member</th>
                      <th>To Member</th>
                      <th>Activity</th>
                      <th>Time</th>
                      <th>Status</th>
                    </tr>
                  </thead>

                  <tbody>
                    {currentData.map((d, index) => (
                      <tr key={d._id}>
                        <td className="index">{index + 1}</td>

                        <td>{d.fromUser?.name || "-"}</td>

                        <td> {d.toUser?.name || "-"}</td>

                        <td>
                          <span className="dur-badge">{d.type}</span>
                        </td>

                        <td>
                          {new Date(d.createdAt).toLocaleTimeString()}
                          <br />
                          <span style={{ fontSize: "12px" }}>
                            {new Date(d.createdAt).toLocaleDateString()}
                          </span>
                        </td>

                        <td>
                          <span
                            className={`badge ${
                              d.status === "ACCEPTED"
                                ? "active"
                                : d.status === "PENDING"
                                  ? "trial"
                                  : "inactive"
                            }`}
                          >
                            {d.status === "ACCEPTED" && "✔️ "}
                            {d.status === "PENDING" && "⏳ "}
                            {d.status === "REJECTED" && "❌ "}
                            {d.status}
                          </span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>

              {/* PAGINATION */}
              <div className="pagination-wrap mx-3">
                <div>
                  Showing {total === 0 ? 0 : startIndex + 1} –{" "}
                  {Math.min(startIndex + perPage, total)} of {total}
                </div>

                <Pagination className="custom-pagination">
                  <Pagination.Prev
                    onClick={() => setCurrentPage((p) => Math.max(p - 1, 1))}
                    disabled={currentPage === 1}
                  />

                  {[...Array(totalPages)].map((_, i) => (
                    <Pagination.Item
                      key={i}
                      active={i + 1 === currentPage}
                      onClick={() => setCurrentPage(i + 1)}
                    >
                      {i + 1}
                    </Pagination.Item>
                  ))}

                  <Pagination.Next
                    onClick={() =>
                      setCurrentPage((p) => Math.min(p + 1, totalPages))
                    }
                    disabled={currentPage === totalPages}
                  />
                </Pagination>
              </div>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
}
